import { render } from "./Signature.vue?vue&type=template&id=2bdd7cd0&scoped=true&ts=true"
import script from "./Signature.vue?vue&type=script&lang=ts"
export * from "./Signature.vue?vue&type=script&lang=ts"

import "./Signature.vue?vue&type=style&index=0&id=2bdd7cd0&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdd7cd0"]])

export default __exports__